export default __webpack_public_path__ + "static/media/women.07fbee62.jpg";